import { render, staticRenderFns } from "./StatsCotizaciones.vue?vue&type=template&id=30fa8679&scoped=true"
import script from "./StatsCotizaciones.vue?vue&type=script&lang=js"
export * from "./StatsCotizaciones.vue?vue&type=script&lang=js"
import style0 from "./StatsCotizaciones.vue?vue&type=style&index=0&id=30fa8679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa8679",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanelContent,VImg,VRow})
